import React, { Component } from 'react';
import "./dashboard.css";
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import GoldMedal from "../../../image/goldmedal.png";

export class DashboardOne extends Component {
  render() {
    return (
        <div className="container subdashboardmargindiv">
          <div className="row">
            <div className="col-8">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h6 className="dashboard-one-headline">Congratulation John!</h6>
                  </div>
                  <div className="col-12">
                    <p className="dashboard-one-Title ">You Have Win Gold Medal</p>
                  </div>
                  <div className="col-12">
                    <span className="dashboard-one-latter">$48.9K</span>
                  </div>
                  <div className="col-12 dashboard-one-button">
                  <Link to="/view-sales" className="UserManagementTDU">
                    <Button variant="success" size="sm" >View Seles</Button>
                  </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4 dashboard-one-imgsec">
              <img src={GoldMedal} alt="Not Found" className="GoldMedal-img" />
            </div>
          </div>
        </div>
    )
  }
}

export default DashboardOne ;